import $ from 'jquery';

$(function () {
    $(document).on('click', '[data-stock-drilldown-metric]', function (e) {
        e.preventDefault();

        const $trigger = $(this);
        const metric = $trigger.data('stock-drilldown-metric');
        if (!metric) {
            return;
        }

        const baseUrl = $trigger.data('stock-drilldown-url') || ('/inventory/overview/drilldowns/' + encodeURIComponent(metric));
        const $modal = $('#stock-overview-drilldown-modal');
        const $body = $('#stock-drilldown-modal-body');

        if (!$modal.length || !$body.length) {
            return;
        }

        $body.html(
            '<div class="text-center py-5">' +
            '<div class="spinner-border text-primary" role="status"><span class="sr-only">Загрузка...</span></div>' +
            '<p class="text-muted mt-2">Загрузка детализации...</p>' +
            '</div>'
        );

        $modal.modal('show');

        $.ajax({
            url: baseUrl,
            method: 'GET',
            dataType: 'html'
        }).done(function (html) {
            $body.html(html);

            const $table = $body.find('.stock-drilldown-table');
            if ($table.length && $.fn.DataTable) {
                const dataUrl = $table.data('url');
                $table.DataTable({
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: dataUrl,
                        type: 'GET'
                    },
                    pageLength: 10,
                    lengthMenu: [[10, 25, 50], [10, 25, 50]],
                    language: {
                        processing: 'Загрузка...',
                        search: 'Поиск:',
                        lengthMenu: 'Показать _MENU_ записей',
                        info: 'Показано с _START_ по _END_ из _TOTAL_ записей',
                        infoEmpty: 'Показано 0 из 0 записей',
                        infoFiltered: '(отфильтровано из _MAX_ записей)',
                        emptyTable: 'Записей для выбранного показателя нет',
                        paginate: {
                            first: 'Первая',
                            previous: '←',
                            next: '→',
                            last: 'Последняя'
                        }
                    },
                    order: [],
                    ordering: false
                });
            }
        }).fail(function () {
            $body.html(
                '<div class="alert alert-danger my-3">' +
                '<i class="fa fa-exclamation-triangle mr-2"></i>Не удалось загрузить детализацию. Попробуйте ещё раз.' +
                '</div>'
            );
        });
    });
});
